import { cn } from '@/lib/utils'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import React from 'react'

const ITEM = 'collapse'

interface IProps {
    open: boolean
    className?: string
    children: React.ReactNode
}

/**
 * Contêiner que expande e retrai o conteúdo animando a altura, com a mesma
 * curva e duração do {@link CollapsibleSection} — mas controlado de fora: o
 * gatilho (checkbox, switch, botão) é responsabilidade de quem usa.
 *
 * Enquanto fechado o conteúdo fica desmontado, então campos de formulário
 * dentro dele saem do react-hook-form ao retrair.
 *
 * @example
 * ```tsx
 * <Collapse open={editando}>
 *   <div className="p-2">Conteúdo</div>
 * </Collapse>
 * ```
 */
export default function Collapse({ open, className, children }: IProps) {
    return (
        <AccordionPrimitive.Root
            type="single"
            collapsible
            value={open ? ITEM : ''}
        >
            <AccordionPrimitive.Item value={ITEM}>
                <AccordionPrimitive.Content
                    // O Content do Radix aponta `aria-labelledby` para o id do
                    // Trigger, que aqui não existe — sem isto a referência
                    // ficaria pendente.
                    aria-labelledby={undefined}
                    className={cn(
                        'overflow-hidden',
                        'data-[state=closed]:animate-accordion-up',
                        'data-[state=open]:animate-accordion-down',
                        className,
                    )}
                >
                    {children}
                </AccordionPrimitive.Content>
            </AccordionPrimitive.Item>
        </AccordionPrimitive.Root>
    )
}
